var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExpand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 9,
    viewBox: "0 0 17 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.855001 0.495992C0.910743 0.440056 0.976979 0.395674 1.04991 0.365391C1.12284 0.335108 1.20103 0.319519 1.28 0.319519C1.35897 0.319519 1.43716 0.335108 1.51009 0.365391C1.58302 0.395674 1.64926 0.440056 1.705 0.495992L8.48 7.27199L15.255 0.495992C15.3677 0.383275 15.5206 0.319952 15.68 0.319952C15.8394 0.319952 15.9923 0.383275 16.105 0.495992C16.2177 0.608709 16.281 0.761586 16.281 0.920992C16.281 1.0804 16.2177 1.23328 16.105 1.34599L8.905 8.54599C8.84926 8.60193 8.78302 8.64631 8.71009 8.67659C8.63716 8.70688 8.55897 8.72247 8.48 8.72247C8.40103 8.72247 8.32284 8.70688 8.24991 8.67659C8.17698 8.64631 8.11074 8.60193 8.055 8.54599L0.855001 1.34599C0.799065 1.29025 0.754683 1.22401 0.7244 1.15108C0.694116 1.07815 0.678528 0.999961 0.678528 0.920992C0.678528 0.842024 0.694116 0.763832 0.7244 0.690901C0.754683 0.61797 0.799065 0.551734 0.855001 0.495992Z",
    fill: "#28262C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpand);
export default __webpack_public_path__ + "static/media/expand.e461a3528725d99c7106fc212229bd05.svg";
export { ForwardRef as ReactComponent };